<template>
    <nav class="tab-bar" ref="bar" v-if="tabs.length > 1" :style="{ '--tab-bar-color': color }">
        <button
            v-for="tab in tabs"
            :key="tab.id"
            type="button"
            class="tab-bar-tab"
            :class="{ 'is-active': tab.id === active }"
            @click="select(tab.id)"
        >
            {{ tab.label }}
        </button>
    </nav>
</template>

<script>
const PROGRAMS = [{ id: "points", label: "dashboard-tabPoints" }];

export default {
    name: "TabBar",
    props: {
        items: {
            type: Array,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: "#2aaa4c",
        },
    },
    data() {
        return {
            active: this.value || (this.items ? null : PROGRAMS[0].id),
        };
    },
    computed: {
        tabs() {
            return this.items || PROGRAMS.map((program) => ({ id: program.id, label: this.t(program.label) }));
        },
    },
    watch: {
        value(value) {
            this.active = value;
        },
        active() {
            this.$nextTick(this.revealActive);
        },
    },
    mounted() {
        this.revealActive();
    },
    methods: {
        revealActive() {
            const bar = this.$refs.bar;
            const tab = bar && bar.querySelector(".is-active");

            if (tab) {
                bar.scrollLeft = tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2;
            }
        },
        select(id) {
            this.active = id;
            this.$emit("select", id);
        },
    },
};
</script>

<style lang="scss">
.tab-bar {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.tab-bar-tab {
  flex: 1 0 0;
  min-width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  min-height: 2.75rem;
  border: none;
  border-bottom: 2px solid #e5e7eb;
  background: transparent;
  color: #9da4ae;
  font-size: clamp(0.875rem, 4vw, 1rem);
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
}

.tab-bar-tab.is-active {
  border-bottom-color: var(--tab-bar-color);
  color: var(--tab-bar-color);
}
</style>
